import ScalingCalculation from "./ScalingCalculation";
import { resizeElementHorizontally } from "../scalingTools";

class ScalingCalculationHorizontal extends ScalingCalculation {
  getClosestYInfo() {
    return [null, null];
  }

  scaleElements({ elements, zoom, canvasOffsets, scale }) {
    return elements.map(element =>
      resizeElementHorizontally({
        element,
        anchorPoint: this.anchorPoint,
        handlerCoordinateName: this.handlerCoordinateName,
        scale,
        zoom,
        offset: this.canvasPositionAndDimensions
      })
    );
  }
}

export default ScalingCalculationHorizontal;
